<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th v-for="(key, keyIndex) in data.keys" :key="keyIndex" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{key.title}}
                </th>
                <th v-if="data.showEdit" scope="col" class="relative px-6 py-3">
                  <span class="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, dataIdx) in data.rows" :key="dataIdx" :class="dataIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'" @click="onClickRow(dataIdx)">
                <td v-for="(key, keyIndex) in data.keys" :key="keyIndex" class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <span v-if="row[key.key].constructor !== Array"> {{ row[key.key] }}</span>
                  <div v-if="row[key.key].constructor === Array" class="flex gap-2">
                    <span v-for="(button, buttonIndex) in row[key.key]" :key="buttonIndex" @click="onButtonClicked(button)" class="text-blue-500 underline font-medium">
                      {{ button.name }}
                    </span>
                  </div>
                </td>
                <td v-if="data.showEdit" class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <a href="#" class="text-indigo-600 hover:text-indigo-900">Edit</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadFile from '../DownloadFile.js'

export default {
  props: [
    'data',
  ],
  methods: {
    onClickRow(row) {
      if (this.data.rows[row].link) {
        this.$router.push(this.data.rows[row].link)
      }
    },
    async onButtonClicked(data) {
      if (data.type == 'VIEW') {
        DownloadFile(document, data.filename, data.link)
      }
      else {
        await this.axios.post(data.link)
      }

      if (data.refresh) {
        this.$emit('dataChanged')
      }
    }
  }
}
</script>